const firebase = require("firebase/app");
export const firebaseui = require("firebaseui");
require("firebase/storage");
require("firebase/firestore");
require("firebase/functions");

console.log("RUNNING", process.env.REACT_APP_projectId);

export const config = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  databaseURL: process.env.REACT_APP_databaseURL,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
};

export const uiConfig = {
  // queryParameterForWidgetMode: "mode",
  // queryParameterForSignInSuccessUrl: "signInSuccessUrl",
  signInSuccessUrl: "/",
  signInOptions: [
    {
      provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    },
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
    }
  ],
  callbacks: {
    signInSuccess: function (currentUser, credential, redirectUrl) {
      console.log(currentUser, credential, redirectUrl);
      return true;
    },
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      console.log(authResult, redirectUrl);
      return true;
    },
    signInFailure: function (error) {
      console.error(error);
    },
  },
  signInFlow: "popup",
  tosUrl: "http://pocketmod.com/privacy",
};

firebase.initializeApp(config);

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

// Initialize the FirebaseUI Widget using Firebase.
const ui = new firebaseui.auth.AuthUI(firebase.auth());

export const isPendingRedirect = function () {
  return ui.isPendingRedirect();
};

export const launchUI = function (selector = "#firebaseui-auth-container") {
  // The start method will wait until the DOM is loaded.
  ui.start(selector, uiConfig);
  // <div id="firebaseui-auth-container" />;
};

export default firebase;



// WEBPACK FOOTER //
// ./src/services/FirebaseService.js